// extracted by mini-css-extract-plugin
module.exports = {"btn":"custom-button_btn__DXpLY"};